module.exports = __webpack_public_path__ + "img/icons8-javascript.303ef549.svg";